import type { LWApiPublicAssetDetailsResultRawI } from '@liquidweb-dev/club-sauce/public/asset/index.raw';
import type { NewOrderedAddOn } from './useNewOrderedAddOns';

/**
 * Returns the ordered add-ons that belong to one of the given servers and that
 * the server's association details do not list yet.
 */
const getAssetsNewOrderedAddOns = (
	newOrderedAddOns: NewOrderedAddOn[],
	assets: Pick<
		LWApiPublicAssetDetailsResultRawI,
		'uniq_id' | 'associationDetails'
	>[],
) =>
	newOrderedAddOns.filter(({ code, related_subaccnt: relatedSubaccnt }) =>
		assets.some(
			({ uniq_id: uniqId, associationDetails }) =>
				uniqId === relatedSubaccnt &&
				!associationDetails?.some(({ type }) => type === code),
		),
	);

export default getAssetsNewOrderedAddOns;
